function Lock() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="-2 0 20 20"
      fill="currentColor"
    >
      <path xmlns="http://www.w3.org/2000/svg" d="M0 19.5V6.5H3V4.5C3 3.25133 3.43783 2.18917 4.3135 1.3135C5.18917 0.437833 6.25133 0 7.5 0C8.74867 0 9.81083 0.437833 10.6865 1.3135C11.5622 2.18917 12 3.25133 12 4.5V6.5H15V19.5H0ZM1.5 18H13.5V8H1.5V18ZM7.5 14.75C7.98583 14.75 8.399 14.5798 8.7395 14.2395C9.07983 13.899 9.25 13.4858 9.25 13C9.25 12.5142 9.07983 12.101 8.7395 11.7605C8.399 11.4202 7.98583 11.25 7.5 11.25C7.01417 11.25 6.601 11.4202 6.2605 11.7605C5.92017 12.101 5.75 12.5142 5.75 13C5.75 13.4858 5.92017 13.899 6.2605 14.2395C6.601 14.5798 7.01417 14.75 7.5 14.75ZM4.5 6.5H10.5V4.5C10.5 3.66667 10.2083 2.95833 9.625 2.375C9.04167 1.79167 8.33333 1.5 7.5 1.5C6.66667 1.5 5.95833 1.79167 5.375 2.375C4.79167 2.95833 4.5 3.66667 4.5 4.5V6.5Z"/>
    </svg>
  );
}

export default Lock;
